const apiKey = process.env.NEXT_PUBLIC_API_KEY!;

type Params = {
  publicBaseUrl: string;
  family: string;
  isCartographyStylesEnabled?: boolean;
  /** Only used by the legacy `/wmts/<legacyType>/style/<family>` endpoint, which serves free overlays from `featured`. */
  legacyType?: 'overlay' | 'featured';
};

/**
 * With `web-maps-rm-cartography-styles` on, overlay styles come from alltrails-carto (`styles/overlays/<family>/<family>.json`):
 * the monolith resolves the current releaseId and redirects `releases/latest` to the immutable CloudFront path for it.
 * Otherwise they come from the legacy `/wmts/*` style endpoint.
 */
export const getOverlayStyleUrl = ({ publicBaseUrl, family, isCartographyStylesEnabled, legacyType = 'overlay' }: Params) =>
  isCartographyStylesEnabled
    ? `${publicBaseUrl}/api/alltrails/cartography/releases/latest/styles/overlays/${family}/${family}.json?key=${apiKey}`
    : `${publicBaseUrl}/wmts/${legacyType}/style/${family}?key=${apiKey}`;
